import InsiderMessengerUpsellPage from "@faire/prototype-playground/workspace/jli/insider-messenger-upsell";
import PosMessengerUpsellPage from "@faire/prototype-playground/workspace/jli/pos-messenger-upsell";
import { Route, Switch } from "react-router-dom";

export function JustinLiRoutes() {
  return (
    <Switch>
      <Route
        path="/jli/insider-messenger-upsell"
        component={InsiderMessengerUpsellPage}
      />
      <Route
        path="/jli/pos-messenger-upsell"
        component={PosMessengerUpsellPage}
      />
    </Switch>
  );
}

export const slug = "jli";
